import React from 'react';
import ListingImageGallery from './ListingImageGallery/ListingImageGallery';
import MobileImageModal from './MobileImageModal/MobileImageModal';

import css from './ListingPage.module.css';

const SectionGallery = props => {
  const {
    listing,
    variantPrefix,
    onMobileImageClick,
    mobileImageModalOpen,
    mobileImageModalInitialIndex,
    onCloseMobileImageModal,
    onManageDisableScrolling,
  } = props;

  const images = listing.images;
  const imageVariants = ['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge'];
  const thumbnailVariants = [variantPrefix, `${variantPrefix}-2x`, `${variantPrefix}-4x`];

  return (
    <section className={css.productGallery} data-testid="carousel">
      <ListingImageGallery
        images={images}
        imageVariants={imageVariants}
        thumbnailVariants={thumbnailVariants}
        onMobileImageClick={onMobileImageClick}
      />

      {/* Mobile Image Modal */}
      {mobileImageModalOpen && (
        <MobileImageModal
          isOpen={mobileImageModalOpen}
          onClose={onCloseMobileImageModal}
          images={images}
          imageVariants={imageVariants}
          initialIndex={mobileImageModalInitialIndex}
          onManageDisableScrolling={onManageDisableScrolling}
        />
      )}
    </section>
  );
};

export default SectionGallery;
